import { useTranslation } from "react-i18next";
import type { DocumentOrder } from "../../../api/content/sourcesApi";
import Field from "../../../ui/forms/Field";
import { FORM_COMPACT_CONTROL_CLASS } from "../../../ui/styles/formStyles";

const ORDERS: readonly DocumentOrder[] = ["creation", "key"];

/**
 * How the document lists are ordered: as the corpus received them, or by key (v1's drawer sorted
 * by ID). In the corpus card's details, labelled, with its choice whole (F137).
 */
export default function DocumentOrderChoice({ order, onOrderChange }: { order: DocumentOrder; onOrderChange: (order: DocumentOrder) => void }) {
  const { t } = useTranslation();
  return (
    <Field layout="inline" label={t("sources.list.order")}>
      {(control) => (
        <select
          {...control}
          value={order}
          className={`${FORM_COMPACT_CONTROL_CLASS} w-auto min-w-0 py-0 text-xs`}
          onChange={(event) => { onOrderChange(ORDERS.find((each) => each === event.target.value) ?? "creation"); }}
        >
          {ORDERS.map((each) => <option key={each} value={each}>{t(`sources.list.orders.${each}`)}</option>)}
        </select>
      )}
    </Field>
  );
}
